import * as React from 'react'

function SvgFlipVertical(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 30 30" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.012 3.976a2 2 0 012.617-1.903l21.645 7.025C28.44 9.8 27.934 13 25.656 13H4.012a2 2 0 01-2-2V3.976zm3 20.668L19.33 20H5.012v4.644zm-.383 3.278a2 2 0 01-2.617-1.902V19a2 2 0 012-2h21.643c2.278 0 2.784 3.2.617 3.902l-21.643 7.02z"
        fill="currentColor"
      />
    </svg>
  )
}

export default SvgFlipVertical
